<template>

	<div>
		<div class="header-item">
			<h1>Users <router-link v-if="user.roles['Admin']" class="btn-edit" :to="`/users/edit/24`"><i class="fa fa-pen"></i></router-link></h1>
		</div>

		<div class="white">
			<div class="row">
				<div class="col-20">

					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li v-if="roles['Admin'] || user.privileges.pages['users/overview']">
									<router-link to="/users/overview">Users</router-link>
								</li>
								<li v-if="roles['Admin'] || user.privileges.pages['users/roles']">
									<router-link to="/users/roles">Roles</router-link>
								</li>
								<li v-if="roles['Admin'] || user.privileges.pages['users/permissions']">
									<router-link to="/users/permissions">Permissions</router-link>
								</li>
							</ul>
						</nav>
					</div>

				</div>
			</div>
		</div>

		<router-view :content="allContent"></router-view>
	</div>

</template>

<script>

import xhrModule from '../modules/xhrModule.js'

export default {
	name: 'objects',

	data () {
		return {
			content: null,
			allContent: null,
			title: 'Users',
			slug: 'users',
			user: this.$store.state.user,
			roles: this.$store.state.user.roles
		}
	},

	created () {
		this.fetchData()
	},

	updated () {
		this.roles = this.$store.state.user ? this.$store.state.user.roles : null
		this.user = this.$store.state.user
	},

	methods: {
		fetchData () {
			var url = '/cms/api/entities'
			xhrModule.get(url, this.getContentCompleteHandler.bind(this))
		},

		getContentCompleteHandler (data) {
			var dataLength = data.meta.count
			this.allContent = Object.values(data.data)

			data = data.data
			// select only contentType = users
			var dataFiltered = []
			var int = 0
			for (var key in data) {
				int++
				if (data[key].settings) {
					if (data[key].settings.contentType) {
						if (data[key].settings.contentType.value === 'users') dataFiltered.push(data[key])
					}
				}
				if (int === dataLength) {
					this.content = dataFiltered
				}
			}
		}
	}
}
</script>
